// 抽選特別枠フラグ
export const SPECIAL_FLAG = {
  FALSE: 0,
  TRUE: 1,
} as const;

export const LIMIT_PER_PAGE = 20;
